import * as fromSession from '../actions/session.actions';

export interface SessionState {
    roles?: [];
    username?: string;
    email?: string;
    fullname?: string;
    uid?: number
}

const initialState: SessionState = null;

export function sessionReducer( state: SessionState = initialState, action: fromSession.sessionActions ): SessionState {
    console.log(action);
    switch ( action.type ) {
    case fromSession.CREATE_SESSION:
        return {
            ...action.payload
        };

    case fromSession.DELETE_SESSION:
        return null;

    default:
        return state;
    }
}


export const selectSession = (state: any) => state.session;
